import About from './About';

const Header = () => {
  return (
    <> 
	  <header>
	    <h3>Algorithmic Field</h3>
	    <p>a generator of painting coordinates and constraints</p>
		<hr />
   	    <About /> 
	  </header>
	</>
  );
}

export default Header;